export function resetNetworkStatus(origin) {
  return {
    type: 'NETWORK_RESET',
    origin,
  };
}
